import { render, staticRenderFns } from "./MultiThreeWitdthPaginationForFilter.vue?vue&type=template&id=c4c5bf1a&scoped=true"
import script from "./MultiThreeWitdthPaginationForFilter.vue?vue&type=script&lang=js"
export * from "./MultiThreeWitdthPaginationForFilter.vue?vue&type=script&lang=js"
import style0 from "./MultiThreeWitdthPaginationForFilter.vue?vue&type=style&index=0&id=c4c5bf1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c5bf1a",
  null
  
)

export default component.exports